<!--
  - Copyright (c) 2019. K+S France & Isagri Ingénierie
  - Ce composant est la vue qui gère l'affichage de la synthèse des besoins
  - SD version du 05/06/2020 18:16:29
  -->


<template>
  <div class="synthesis">
    <h1 class="form-title">{{ $t('synthesis_title') }}</h1>
    <div class="graph__wrapper">
      <div id="labelNeads" v-html="$options.filters.capitalize($t('synthesis_neads'))"></div>
      <div id="labelContribution" v-html="$options.filters.capitalize($t('synthesis_contributions'))"></div>
      <div class="helpIcon"><a href="#/aide/1029">
          <v-icon large color="primary">info</v-icon>
        </a>
      </div>
      <div class="graphSVG">

        <svg version="1.1" id="barrique" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 461 472" enable-background="new 0 0 461 472" xml:space="preserve">
<ellipse id="fuite" fill-rule="evenodd" clip-rule="evenodd" fill="#C6E9FF" cx="230.5" cy="350.2" rx="164" ry="66"/>
          <g id="arrieredroit_1_" enable-background="new    ">
	<g>
		<polygon fill="#D6B173" points="261.6,4.7 261.6,287.2 259.5,292 259.5,9.5 		"/>
	</g>
            <g>
		<polygon fill="#C7B299" points="289.8,20.4 289.8,290.3 285.7,294.8 285.7,25 		"/>
	</g>
            <g>
		<polygon fill="#D6B173" points="316.3,19.7 316.3,297.4 310.3,301.7 310.3,23.9 		"/>
	</g>
            <path fill="#F9E5B1" d="M289.8,14.7c-9.1-1.3-18.5-2.4-28.2-3.1l-2.1,4.8c9,0.6,17.8,1.6,26.2,2.8c8.6,1.3,16.8,2.8,24.6,4.7l6-4.2
		C307.9,17.7,299,16.1,289.8,14.7z"/>
            <path fill="#EFC681" d="M332.5,43.5c-6.9-2.4-14.3-4.5-22.2-6.3v262.4c7.9,1.9,15.3,4,22.2,6.3c6.9,2.4,13.3,5,19.2,7.8V51.3
		C345.8,48.4,339.4,45.8,332.5,43.5z"/>
            <path fill="#F9E5B1" d="M340.2,39.7c-7.4-2.5-15.4-4.8-23.9-6.8l-6,4.2c7.9,1.9,15.3,4,22.2,6.3c6.9,2.4,13.3,5,19.2,7.8l9.2-3.1
		C354.6,45.1,347.7,42.3,340.2,39.7z"/>
            <path fill="#EFC681" d="M367.2,48.6c-4.5-3.2-9.8-6.2-15.6-9v274.1c5.8,2.8,11,5.8,15.6,9c4.5,3.2,8.4,6.5,11.5,10V58.6
		C375.6,55.1,371.8,51.8,367.2,48.6z"/>
            <path fill="#F9E5B1" d="M377.6,46.2c-4.9-3.4-10.5-6.7-16.8-9.7l-9.2,3.1c5.8,2.8,11,5.8,15.6,9c4.5,3.2,8.4,6.5,11.5,10l11.2-1.7
		C386.6,53.2,382.5,49.6,377.6,46.2z"/>
            <g>
		<rect x="388.1" y="69.9" fill="#E0BA79" width="12" height="284.4"/>
	</g>
            <path fill="#F9E5B1" d="M397.5,58.1c-1.7-4-4.2-7.8-7.5-11.5l-11.2,1.7c3.1,3.4,5.4,7,7,10.7c1.5,3.6,2.3,7.2,2.3,11h12
		C400,65.9,399.2,61.9,397.5,58.1z"/>
            <path fill="#EFC681" d="M385.7,58.9c-1.6-3.7-3.9-7.2-7-10.7v284.4c3.1,3.4,5.4,7,7,10.7c1.5,3.6,2.3,7.2,2.3,11V69.9
		C388.1,66.2,387.3,62.5,385.7,58.9z"/>
            <path fill="#EFC681" d="M285.7,19.3L285.7,19.3c-8.4-1.3-17.2-2.2-26.2-2.9v269.9c9,0.6,17.8,1.6,26.2,2.8v5.7
		c8.6,1.3,16.8,2.8,24.6,4.7V24C302.5,22.1,294.3,20.6,285.7,19.3z"/>
</g>
          <g id="arrieregauche_1_" enable-background="new    ">
	<path fill="#F9E5B1" d="M232.5,3.7L232.5,3.7c-9.9,0-19.6,0.4-29.1,1l2.1,4.8c8.8-0.6,17.8-1,27-1v0c9.2,0,18.2,0.3,27,1l2.1-4.8
		C252.1,4.1,242.4,3.7,232.5,3.7z"/>
            <path fill="#EFC681" d="M232.5,8.6L232.5,8.6c-9.2,0-18.2,0.3-27,1V292c8.8-0.6,17.8-1,27-1s18.2,0.3,27,1V9.5
		C250.7,8.9,241.7,8.6,232.5,8.6z"/>
            <g>
		<polygon fill="#C1A271" points="205.5,9.5 205.5,292 203.4,287.2 203.4,4.7 		"/>
	</g>
            <path fill="#EFC681" d="M179.3,27.2c-8.6,1.3-18,1.4-25.8,3.2l0.2,269.4c7.8-1.8,17.1-3.7,25.7-4.9c8.4-1.2,17.2-2.2,26.2-2.8V24.4
		C196.5,25,187.7,26,179.3,27.2z"/>
            <path fill="#F9E5B1" d="M203.4,19.6c-9.7,0.7-19.2,1.7-28.2,3.1c-9.2,1.4-18.1,3.1-26.5,5l6,4.2c7.8-1.8,16-3.4,24.6-4.7
		c8.4-1.2,17.2-2.2,26.2-2.8L203.4,19.6z"/>
            <g>
		<path fill="#EFC681" d="M154.7,12.1L153,301c-6.2,0.4-13.6,2.5-20.5,4.9V18.5C139.4,16.1,148.5,12.5,154.7,12.1z"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M154.7,12.1c-7.9,1.9-15.3,4-22.2,6.3l-7.7-3.7c7.5-2.5,15.4-4.8,23.9-6.8L154.7,12.1z"/>
	</g>
            <g>
		<polygon fill="#D6B173" points="113.3,26.2 113.3,313.6 104.2,310.5 104.2,23.1 		"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M132.5,18.5c-6.9,2.4-13.3,5-19.2,7.8l-9.2-3.1c6.3-3,13.2-5.8,20.6-8.4L132.5,18.5z"/>
	</g>
            <g>
		<path fill="#EFC681" d="M132.5,18.5l0,287.4c-6.9,2.4-13.3,5-19.2,7.8V26.3C119.2,23.5,125.6,20.8,132.5,18.5z"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M113.3,34.7c-5.8,2.8-11,5.8-15.6,9l-10.4-2.4c4.9-3.4,10.5-6.7,16.8-9.7L113.3,34.7z"/>
	</g>
            <g>
		<polygon fill="#C7B299" points="97.8,48.6 97.8,322.7 87.4,320.2 87.4,46.2 		"/>
	</g>
            <g>
		<path fill="#EFC681" d="M113.3,34.7l0,279c-5.8,2.8-11,5.8-15.6,9v-279C102.3,40.5,107.5,37.5,113.3,34.7z"/>
	</g>
            <g>
		<path fill="#EFC681" d="M97.8,43.7l0,279c-4.5,3.2-8.4,6.5-11.5,10v-279C89.4,50.2,93.2,46.9,97.8,43.7z"/>
	</g>
            <g>
		<polygon fill="#D6B173" points="86.3,53.7 86.3,332.7 75,331 75,52 		"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M97.8,43.7c-4.5,3.2-8.4,6.5-11.5,10L75,52c3.4-3.8,7.5-7.4,12.4-10.8L97.8,43.7z"/>
	</g>
            <g>
		<rect x="65" y="82.7" fill="#C7B299" width="12" height="271.6"/>
	</g>
            <path fill="#EFC681" d="M79.3,69.3c-1.5,3.6-2.3,7.2-2.3,11v274.1c0-3.7,0.8-7.4,2.3-11c1.6-3.7,3.9-7.2,7-10.7V58.6
		C83.2,62,80.8,65.6,79.3,69.3z"/>
            <path fill="#F9E5B1" d="M75,56.9c-3.3,3.7-5.8,7.5-7.5,11.5c-1.6,3.8-2.5,7.8-2.5,11.8h12c0-3.7,0.8-7.4,2.3-11
		c1.6-3.7,3.9-7.2,7-10.7L75,56.9z"/>
</g>
          <g id="eau_1_">
	<polygon fill="#C6E9FF" points="86.3,101.9 86.3,376 75,377.6 75,103.6 	"/>
            <path fill="#C6E9FF" d="M232.5,65.3c-90.6,0-164,29.5-164,66v227h0.1c2.6,35.5,75,64,163.9,64s161.3-28.5,163.9-64h0.1v-227
		C396.5,94.8,323.1,65.3,232.5,65.3z"/>
</g>
          <g id="devantgauche_2_">
	<g>
		<polygon fill="#D6B173" points="86.3,96.5 86.8,376.8 75,377.6 75,98.2 		"/>
	</g>
            <path fill="#F9E5B1" d="M79.3,85.9c-1.5-3.6-2.3-7.2-2.3-11H65c0,4,0.9,8,2.5,11.8c1.7,4,4.2,7.8,7.5,11.5l11.3-1.7
		C83.2,93.1,80.8,89.5,79.3,85.9z"/>
            <path fill="#C1A271" d="M67.5,86.7c-1.6-3.8-2.5-7.8-2.5-11.8v279.4c0,4,0.9,8,2.5,11.8c1.7,4,4.2,7.8,7.5,11.5V98.2
		C71.7,94.5,69.2,90.7,67.5,86.7z"/>
            <g>
		<path fill="#F9E5B1" d="M97.8,114.7c-4.5-3.2-8.4-6.5-11.5-10L75,106.4c3.4,3.8,7.5,7.4,12.4,10.8L97.8,114.7z"/>
              <path fill="#F9E5B1" d="M97.8,114.8l-10.4,2.4c4.9,3.4,10.5,6.7,16.8,9.7l9.2-3.1C107.5,121,102.3,118,97.8,114.8z"/>
	</g>
            <path fill="#C1A271" d="M87.4,117.2L87.4,117.2c-4.9-3.4-9-7-12.4-10.8v271.2c3.4,3.8,7.5,7.4,12.4,10.8c4.9,3.4,10.5,6.7,16.8,9.7
		V126.9C97.9,123.9,92.3,120.6,87.4,117.2z"/>
            <g>
		<polygon fill="#C7B299" points="132.5,126.7 132.5,402.8 124.8,406.5 124.8,130.4 		"/>
	</g>
            <g>
		<polygon fill="#EFC681" points="154.7,126.9 154.7,409.1 148.7,413.3 148.7,131.1 		"/>
	</g>
            <path fill="#F9E5B1" d="M132.5,120.5c-6.9-2.4-13.3-5-19.2-7.8l-9.2,3.1c6.3,3,13.2,5.8,20.6,8.4c7.5,2.5,15.4,4.8,23.9,6.8l6-4.2
		C146.8,125,139.4,122.9,132.5,120.5z"/>
            <path fill="#C1A271" d="M124.8,124.3L124.8,124.3c-7.5-2.6-14.4-5.4-20.6-8.4v282.2c6.3,3,13.2,5.8,20.6,8.4
		c7.5,2.5,15.4,4.8,23.9,6.8V131.1C140.3,129.1,132.3,126.8,124.8,124.3z"/>
</g>
          <polygon fill="#D6B173" points="154.6,30.2 156.4,31.5 154.9,73.2 154.6,31.7 "/>
          <polyline fill="#D6B173" points="112.8,34.9 113.3,85.9 113.3,34.7 104.2,31.5 "/>
          <polygon fill="#D6B173" points="75,56.9 86.1,58.8 87.4,100.5 86.3,58.6 "/>
          <polygon fill="#C1A271" points="203.4,19.6 205,24.3 205.3,66.2 205.5,24.4 "/>
          <polygon fill="#D6B173" points="75,100.2 75,183.6 75.4,100.6 "/>
          <polygon fill="#D6B173" points="104.2,126.2 103.4,126.6 104.2,366.7 104.2,126.9 "/>
          <polygon fill="#D6B173" points="261.6,11.6 259.5,16.4 259.5,66.2 260.4,16.3 "/>
          <polygon fill="#D6B173" points="311.7,22.8 310.3,23.9 310.3,73.2 310.7,24 "/>
          <polygon fill="#D6B173" points="351.7,50.1 350.7,50.8 351.7,85.9 351.7,51.3 "/>
          <polygon fill="#D6B173" points="378.7,57.7 378.2,58 378.7,101.9 378.7,58.6 "/>
          <g id="devantdroit_1_">
	<g>
		<polygon fill="#E8D0B2" points="397.5,92.1 397.5,366.1 385.7,365.3 385.7,91.2 		"/>
	</g>
            <path fill="#EFC681" d="M397.5,92.1c-1.7,4-4.2,7.8-7.5,11.5v274.1c3.3-3.7,5.8-7.5,7.5-11.5c1.7-3.8,2.5-7.8,2.5-11.8V80.2
		C400,84.3,399.2,88.2,397.5,92.1z"/>
            <path fill="#F9E5B1" d="M388.1,80.2c0,3.7-0.8,7.4-2.3,11c-1.6,3.7-3.9,7.2-7,10.7l11.2,1.7c3.3-3.7,5.8-7.5,7.5-11.5
		c1.7-3.8,2.5-7.8,2.5-11.8H388.1z"/>
            <g>
		<polygon fill="#E0BA79" points="390,103.6 389.1,378.4 378.7,376 378.7,101.9 		"/>
	</g>
            <g>
		<polygon fill="#C1A271" points="360.8,137 360.8,398.1 351.7,395 351.7,133.9 		"/>
	</g>
            <path fill="#F9E5B1" d="M378.7,109.7c-3.1,3.5-7,6.8-11.5,10c-4.5,3.2-9.8,6.3-15.6,9.1l9.2,3.1c6.3-3,11.9-6.4,16.8-9.8
		c4.9-3.4,9-7,12.4-10.8L378.7,109.7z"/>
            <g>
		<path fill="#EFC681" d="M360.8,128l0,270.2c-6.3,3-13.2,5.8-20.7,8.4l0-270.2C347.7,133.8,354.6,131,360.8,128z"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M360.8,128c-6.3,3-13.2,5.8-20.7,8.4l-7.7-3.7c6.9-2.4,13.3-5,19.2-7.8L360.8,128z"/>
	</g>
            <g>
		<polygon fill="#C1A271" points="328,140 328.1,410.8 322,406.5 322,135.8 		"/>
	</g>
            <g>
		<path fill="#F9E5B1" d="M340.2,136.4c-7.4,2.5-9.7,3.1-12.2,3.7l-6-4.2c2.9-0.7,3.6-0.8,10.5-3.2L340.2,136.4z"/>
	</g>
            <g>
		<path fill="#EFC681" d="M340.2,136.4l0,270.2c-3.8,1.3-6,2.2-12,4.3L328,140C332.4,139,332.9,138.7,340.2,136.4z"/>
	</g>
            <path fill="#EFC681" d="M377.6,122.1c-4.9,3.4-10.5,6.8-16.8,9.8v266.2c6.3-3,11.9-6.3,16.8-9.7c4.9-3.4,9-7,12.4-10.8V111.4
		C386.6,115.1,382.5,118.7,377.6,122.1z"/>
</g>
          <polygon fill="#E0BA79" points="397.5,91.5 397.7,91.8 397.7,185.7 397.5,93.3 "/>
          <polygon fill="#E0BA79" points="378.7,101.9 390,103.6 390,242.4 389.4,104.2 "/>
          <polygon fill="#C1A271" points="361.2,131.8 361.4,364.2 360.8,132 "/>
          <path id="cerclage" fill="#423329" d="M397.6,121.7c-1.9,4.2-4.4,8.1-7.5,11.5c-3.7,4-7.9,7.7-12.4,10.8c-5.3,3.7-10.9,6.9-16.8,9.7
	c-6.7,3.2-13.6,6-20.6,8.4c-7.5,2.5-15.4,4.8-23.9,6.8c-8.4,2-17.2,3.7-26.5,5c-9.1,1.3-18.5,2.4-28.2,3.1c-9.5,0.7-19.2,1-29.1,1
	c-9.9,0-19.6-0.4-29.1-1c-9.7-0.7-19.2-1.7-28.2-3.1c-9.2-1.4-18.1-3.1-26.5-5c-8.5-2-16.5-4.3-23.9-6.8c-7-2.4-13.9-5.2-20.6-8.4
	c-5.8-2.8-11.5-6-16.8-9.7c-4.5-3.1-8.7-6.7-12.4-10.8c-3.1-3.4-5.7-7.3-7.5-11.5c-1.6-3.7-2.5-7.8-2.5-11.8V140
	c0,4.1,0.9,8.1,2.5,11.8c1.9,4.2,4.4,8.1,7.5,11.5c3.7,4,7.9,7.7,12.4,10.8c5.3,3.7,10.9,6.9,16.8,9.7c6.7,3.2,13.6,6,20.6,8.4
	c7.5,2.5,15.4,4.8,23.9,6.8c8.4,2,17.2,3.7,26.5,5c9.1,1.3,18.5,2.4,28.2,3.1c9.5,0.7,19.2,1,29.1,1c9.9,0,19.6-0.4,29.1-1
	c9.7-0.7,19.2-1.7,28.2-3.1c9.2-1.4,18.1-3.1,26.5-5c8.5-2,16.5-4.3,23.9-6.8c7-2.4,13.9-5.2,20.6-8.4c5.8-2.8,11.5-6,16.8-9.7
	c4.5-3.1,8.7-6.7,12.4-10.8c3.1-3.4,5.7-7.3,7.5-11.5c1.6-3.7,2.5-7.8,2.5-11.8v-30.2C400.1,113.9,399.2,117.9,397.6,121.7z"/>
</svg>
      </div>
      <div class="graph">
        <div class="elem__list">
          <div class="elem__block ">
            <div class="elem__neads">{{ neads.k2o | intLocal }}</div>
            <div class="elem__graph">
              <div
                :class="{ elem__value: true, 'c-k': true, 't-black': h_k < 16 }"
                :style="{ height: h_k + 'px' }"
              >
                {{ synthesis.k2o | intLocal }}
              </div>
            </div>
            <div class="elem__label" v-html="$t('k2o')"></div>
          </div>
          <div class="elem__block ">
            <div class="elem__neads">{{ neads.mgo | intLocal }}</div>
            <div class="elem__graph">
              <div
                :class="{ elem__value: true, 'c-m': true, 't-black': h_m < 16 }"
                :style="{ height: h_m + 'px' }"
              >
                {{ synthesis.mgo | intLocal }}
              </div>
            </div>
            <div class="elem__label" v-html="$t('mgo')"></div>
          </div>
          <div class="elem__block ">
            <div class="elem__neads">{{ neads.so3 | intLocal }}</div>
            <div class="elem__graph">
              <div
                class="elem__value t-black c-s"
                :style="{ height: h_s + 'px' }"
              >
                {{ synthesis.so3 | intLocal }}
              </div>
            </div>
            <div class="elem__label" v-html="$t('so3')"></div>
          </div>
        </div>
      </div>
    </div> <!--.graph__wrapper-->
    <v-layout row nowrap commentaire mt-4>
      <p v-html="explication"></p>
    </v-layout>
    <div class="pform contour">
      <p v-html="labelPotassium"></p>
      <div class="pform__wrapper">
        <ul class="radio-switch">
          <li class="radio-switch__item">
            <input
              class="radio-switch__input sr-only"
              type="radio"
              name="formPotassium"
              id="chlorure"
              checked
              value="chlorure"
              @change="switchPform('chlorure')"
            />
            <label class="radio-switch__label" for="chlorure" v-html="$t('synthesis_chlorure')"></label>
          </li>
          <li class="radio-switch__item">
            <input
              class="radio-switch__input sr-only"
              type="radio"
              name="formPotassium"
              id="sulfate"
              value="sulfate"
              @change="switchPform('sulfate')"
            />
            <label class="radio-switch__label" for="sulfate" v-html="$t('synthesis_sulfate')"></label>
            <div aria-hidden="true" class="radio-switch__marker"></div>
          </li>
        </ul>
      </div>
    </div> <!--.pform-->
    <p v-html="$t('synthesis_pform_help')" class="moyen mt-1"></p>
    <v-layout row nowrap justify-end>
      <v-btn color="primary" class="btn-ks white--text" @click="next">{{ $t("btn_next") }}</v-btn>
    </v-layout>
  </div>
</template>

<script>
/* eslint-disable no-console */

export default {
  name: "Synthesis",
  data() {
    return {
      labelPotassium: this.$options.filters.capitalize(
        this.$i18n.t("synthesis_pform")
      ),
      p_form: "chlorure", // valeur par defaut
      hauteur_max: 183, // Note : valeur à reporter dans la css L1:259 !!
      explication_string: null
    };
  },

  computed: {
    synthesis() {
      return this.$store.getters.getSynthesis;
    },
    neads() {
      return this.$store.getters.getNeads;
    },
    h_m() {
      if (this.neads.mgo !== 0) {
        // dans le cas où il n'y pas besoin d'un élément on ferme la barrique (validé par CM le 03/05/2019
        let hauteur = this.calc_height(this.synthesis.mgo, this.neads.mgo);
        if (isNaN(hauteur)) {
          return 0;
        } else {
          return hauteur > this.hauteur_max ? this.hauteur_max : hauteur;
        }
      } else {
        return this.hauteur_max;
      }
    },
    h_k() {
      if (this.neads.k2o !== 0) {
        let hauteur = this.calc_height(this.synthesis.k2o, this.neads.k2o);
        if (isNaN(hauteur)) {
          return 0;
        } else {
          return hauteur > this.hauteur_max ? this.hauteur_max : hauteur;
        }
      } else {
        return this.hauteur_max;
      }
    },
    h_s() {
      if (this.neads.so3 !== 0) {
        let hauteur = this.calc_height(this.synthesis.so3, this.neads.so3);
        if (isNaN(hauteur)) {
          return 0;
        } else {
          return hauteur > this.hauteur_max ? this.hauteur_max : hauteur;
        }
      } else {
        return this.hauteur_max;
      }
    },
    fuite() {
      return this.h_m + this.h_k + this.h_s < this.hauteur_max * 3;
    },
    explication() {
      if (this.fuite) {
        return this.$store.getters.getPhraseId('FUIT');
      } else {
        return this.$store.getters.getPhraseId('FUITPAS');
      }
    },
    // h_n() {
    //   let hauteur = this.calc_height( this.synthesis.n, this.neads.n );
    //   if(isNaN(hauteur)) {
    //     return 0;
    //   } else {
    //     return (hauteur > this.hauteur_max) ? this.hauteur_max : hauteur;
    //   }
    // },

    // h_p() {
    //   let hauteur = this.calc_height( this.synthesis.p, this.neads.p2o5 );
    //   if(isNaN(hauteur)) {
    //     return 0;
    //   } else {
    //     return (hauteur > this.hauteur_max) ? this.hauteur_max : hauteur;
    //   }
    // },
    reco() {
      return this.$store.getters.getRecommandation;
    }
  },

  methods: {
    calc() {
      console.log(this.reco);
      this.$store.dispatch("calcSynthesis").then(
        () => {
          // const synt = this.$store.getters.getSynthesis;
          const params = {
            //f_form: synt.potassiumForm,
            apportK2O: this.reco.k2o,
            apportMgO: this.reco.mgo,
            apportSO3: this.reco.so3,
            apportK2O_100: this.reco.k2o,
            apportMgO_100: this.reco.mgo,
            apportSO3_100: this.reco.so3
          };

            this.$store.dispatch("motor", params).then();

            if (this.fuite) {
                console.log("SVG", SVG.get("fuite"));
                SVG.get("fuite")
                    .animate(1500, "<", 300)
                    .cy(352)
                    .radius(200, 100);
            }
        },
        erreur => {
          console.error(erreur);
        }
      );
    },
    calc_height(give, nead) {
      return Math.round(give / nead * this.hauteur_max);
    },
    switchPform(value) {
      console.info("Changement de la forme du potassium : ", value);
      this.$store.dispatch("storePotassiumForm", value).then(
          console.info("Changement de forme potassium enregistrée : ", value)
        );
    },
    next() {
      this.$store.dispatch("updateRoutes", this.$router.currentRoute.path).then(
        () => {
          this.$router.push({ path: "preconisation" }); // on change de page
        },
        () => {
          console.error("Erreud de routage ");
        }
      );
    }
  },
  beforeMount() {
    this.calc();
    this.switchPform(this.p_form);
  }
};
</script>

<style lang="scss">
$c-site1: #024ea1;
$c-n: #056369; //#e3000b;
$c-s: #d7c90d; //#ffcc00;
$c-p: #f9b122; //#f9b11f;
$c-m: #377150; //#008c48;
$c-k: #CE1719; //#009ee3;

$largeur: 50px;
$hauteur: 216px;

.synthesis {
  .switch2e {
    margin-top: -5px;

    .v-input__control {
      margin: 0 auto;
    }
  }

  .v-input--selection-controls__input {
    margin: 0 auto;
  }
}

.graph {
  height: $hauteur;
}

.elem__list {
  height: $hauteur;
}

.elem__block {
  width: $largeur;
}

.elem__graph {
  height: $hauteur;
  width: $largeur;
}

.elem__value {
  width: $largeur;
}

#labelNeads {
  position: absolute;
  top: 157px;
  left: 0;
  z-index: 5;
}

#labelContribution {
  position: absolute;
  bottom: 40px;
  left: 0;
  z-index: 5;
}

.commentaire {
  margin-top: -1.25em;
  z-index: 100;
}

:root {
  // style
  --radio-switch-width: 150px;
  --radio-switch-height: 32px;
  --radio-switch-padding: 3px;
  --radio-switch-radius: 50em;
  --color-contrast-low: #024ea1;
  --color-white: #fff;
  --color-primary: #024ea1;
  --color-contrast-lower: lightgray;

  // animation
  --radio-switch-animation-duration: 0.3s;
}

.pform__wrapper {
  width: var(--radio-switch-width);
  margin: 0 auto;
  margin-bottom: 0.5em;
}

.radio-switch {
  position: relative;
  display: inline-flex;
  padding: var(--radio-switch-padding);
  border-radius: calc(var(--radio-switch-radius) * 1.4);
  border: 1px solid var(--color-contrast-low);
  margin: 0 auto;

  &:focus-within,
  &:active {
    box-shadow: 0 0 0 3px var(--color-contrast-lower); // focus effect
  }

  input[type="radio"] {
    display: none;
  }
}

.radio-switch__item {
  position: relative;
  display: inline-block; // flexbox fallback
  height: calc(var(--radio-switch-height) - 2 * var(--radio-switch-padding));
  width: calc(var(--radio-switch-width) * 0.5 - var(--radio-switch-padding));
}

.radio-switch__label {
  position: relative;
  z-index: 2;
  display: block;
  border-radius: var(--radio-switch-radius);
  line-height: calc(
    var(--radio-switch-height) - 2 * var(--radio-switch-padding)
  );
  text-align: center;
  cursor: pointer;
  font-size: var(--text-sm);
  user-select: none;
  transition: all var(--radio-switch-animation-duration);

  .radio-switch__input:checked ~ & {
    color: var(--color-white);
    //@include fontSmooth;
  }

  .radio-switch__input:focus ~ & {
    // focus effect in browsers not supporting :focus-within
    background-color: lighten($c-site1, 0.6);
  }

  :not(*):focus-within, // trick to detect :focus-within support -> https://css-tricks.com/using-feature-detection-conditionals-and-groups-with-selectors/
    .radio-switch__input:focus ~ & {
    // reset focus style for browsers supporting :focus-within
    background-color: transparent;
  }
}

.radio-switch__marker {
  position: absolute;
  z-index: 1;
  top: 0;
  left: -100%;
  border-radius: var(--radio-switch-radius);
  background-color: var(--color-primary);
  height: calc(var(--radio-switch-height) - 2 * var(--radio-switch-padding));
  width: calc(var(--radio-switch-width) * 0.5 - var(--radio-switch-padding));
  transition: transform var(--radio-switch-animation-duration);

  .radio-switch__input:checked ~ & {
    transform: translateX(100%);
  }
}
</style>
